import { DOCUMENT, NgClass, NgIf } from '@angular/common';
import {
  Component,
  DoCheck,
  ElementRef,
  EventEmitter,
  Inject,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
  ViewChild,
  DestroyRef,
  inject
} from '@angular/core';
import { GtErrorResponse } from '../../models/GtErrorResponse';
import { LOGO } from '../../models/logo.enum';
import { Position } from '../../models/Position';
import { CompanyLogoService } from '../../services/company-logo.service';
import { SessionStorageService } from '../../services/session-storage.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
    selector: 'gt-company-logo',
    templateUrl: 'gt-company-logo.component.html',
    styleUrls: ['gt-company-logo.component.scss'],
    imports: [NgClass, NgIf]
})
export class GtCompanyLogoComponent implements OnChanges {

  @Input()
  public loginChallenge = '';

  @Input()
  public domainName = '';

  @Input()
  public position = Position.LEFT;

  @Input()
  public logoType = LOGO.CLIENT;

  @Output()
  public error: EventEmitter<GtErrorResponse> = new EventEmitter();

  @Input()
  public updateHeightWidth = false;

  public logoSrc = null;
  private destroyRef = inject(DestroyRef);

  constructor(private _companyLogoService: CompanyLogoService,
              private _sessionStorage: SessionStorageService,
              @Inject(DOCUMENT) private document: any) {
    this.companyLogoSubscriber = this.companyLogoSubscriber.bind(this);
    this.logoErrSubscriber = this.logoErrSubscriber.bind(this);
  }

  public ngOnChanges(changes: SimpleChanges) {
    this.logoSrc = this._companyLogoService.logoSrc;
    if (this.logoSrc) {
      return;
    }

    if (changes.loginChallenge || changes.domainName) {
      this._companyLogoService.getCompanyLogo(this.loginChallenge, this.domainName, this.logoType)
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe(this.companyLogoSubscriber, this.logoErrSubscriber);
    }
  }

  public get imagePosition(): string {
    return this.position;
  }

  private companyLogoSubscriber(res) {
    this.logoSrc = `data:image/png;base64,${res?.image}`;
    this._companyLogoService.logoSrc = this.logoSrc;
  }

  private logoErrSubscriber(err) {
    const {error} = err;
    this.error.emit(error);
  }
}
